import { Component, OnInit } from '@angular/core';
import { HttpMethod, UserType } from 'src/constants/constant';
import {Location} from '@angular/common';
import { ServiceManagerService } from '../service-manager.service';
import { HttpCustomOptions } from 'src/services/http-interceptor.service';

@Component({
  selector: 'app-content',
  templateUrl: './content.component.html',
  styleUrls: ['./content.component.scss']
})
export class ContentComponent implements OnInit {

  currentUserType: string = UserType.MENTOR;
  isEditForm: any = false;
  currentContent: any = "";
  isPolicy: any;
  constructor(public location: Location, public serviceManager: ServiceManagerService) { }

  ngOnInit(): void {
  }

  getContent(isPolicy: Boolean){
    this.currentContent = ""
    this.isEditForm = true
    this.isPolicy = isPolicy
    var body ={
      is_policy: isPolicy,
      user_type: this.currentUserType
    }
    this.serviceManager.CallBackendServiceAPI("get-content", body).subscribe( (data: any)=>{
      if(data?.response){
        this.currentContent =  decodeURIComponent(escape( atob(data?.response?.data)));
      }
    })
  }

  updateContent(){
    const customOptions : HttpCustomOptions = {
      showErrorMessage: true,
      showSuccessMessage: true,
      createLoaderAction: true
    }
    var body ={
      data : btoa(unescape(encodeURIComponent(this.currentContent))),
      is_policy: this.isPolicy,
      user_type: this.currentUserType
    }
    this.serviceManager.CallBackendServiceAPI("update-content", body, HttpMethod.POST, customOptions).subscribe( (data: any)=>{
      if(data){
        console.log("success")
      }
    })
  }
}
